module.exports = __webpack_public_path__ + "img/canbadge-round-76mm-glitter.0299d31a.png";